module.exports = __webpack_public_path__ + "img/wz-7-1-4.08c0d055.jpg";